export async function copyTextToClipboard(text) {
    if (!text) return false;

    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (error) {
            // MAX WebView may expose Clipboard API but reject the write.
            console.warn('Clipboard API copy failed, trying fallback:', error);
        }
    }

    if (typeof document === 'undefined' || !document.body) return false;

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);

    let copied = false;
    try {
        textarea.select();
        copied = document.execCommand('copy');
    } catch (error) {
        console.warn('Clipboard fallback failed:', error);
    } finally {
        document.body.removeChild(textarea);
    }

    return copied;
}
